import { parse } from 'query-string';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { getCollectionData, onDecryptData, updateCollectionData } from '../../util/api';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';
export const EMPLOYEEEMAIL_SUCCESS = 'app/AuthenticationPage/EMPLOYEEEMAIL_SUCCESS';


const initialState = {
  ischeckprovider: false,
  isdecrypted: null,
  isuserId: null,
  firstname: null,
  lastname: null,
  isSaleAgency: null,
  invitedEmailSent: null,
  organsationEmail: null,
  AgentUserId: null,
  saleagencyName: null,
  docuCode: null,

}
export default function AuthenticationPage(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEEEMAIL_SUCCESS:
      return {
        ...state,
        isdecrypted: payload
      };
    default:
      return state;
  }
}
export const inviteeUserSuccess = (res) => ({ type: EMPLOYEEEMAIL_SUCCESS, payload: res });


const InviteeUser = (params) => async (dispatch) => {
  try {
    const token = params.InviteeUrl.toString();
    const res = await onDecryptData(token);
    const inviteEmail = res.decrypted.email;

    const query = {
      email: inviteEmail,
    };
    const options = { limit: 1 };

    // Get data from collection
    const response = await getCollectionData({
      tableName: "Invitation_Data",
      query,
      options,
      fnCallback: false,
    });

    let data = response.data[0];
    // const {_id} = data || {};
    const { _id, email, lastName, firstName, url, inviterName, inviterId, reason, country } = data || {};

    const payload = {
      firstName,
      lastName,
      email: email,
      country: country,
      reason: reason,
      inviterId,
      inviterName,
      isUsed: false,
      status: "expired",
      url: url
    };
    if (!data) {
      return null;
    }

    const today = new Date();
    const expiryDate = new Date(data.expiresAt);

    const isSameDate = expiryDate.toDateString() === today.toDateString();

    if (isSameDate && data.status === "pending") {

      await updateCollectionData({
        id: _id,
        tableName: "Invitation_Data",
        payload: payload,


        fnCallback: false
      });

      // Fetch updated data
      const updatedResponse = await getCollectionData({
        tableName: "Invitation_Data",
        query,
        options,
        fnCallback: false,
      });

      data = updatedResponse.data[0];
    }
    dispatch(inviteeUserSuccess({ data }));
    return data;

  } catch (error) {
    console.error("Error in InviteeUser:", error);
    return null;
  }
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  const searchValues = search && search.length ? parse(search.slice(1)) : {};
  console.log('searchValues', searchValues)
  if (searchValues.user) {
    dispatch(InviteeUser({ InviteeUrl: searchValues.user }));
  }
  return dispatch(fetchPageAssets(pageAsset, true));
};
